import React, { Component } from 'react';
import { Modal, Button, Table} from 'react-bootstrap';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS
export default class ProcessWise extends Component {  
  constructor(props, context) {
    super(props, context);    
    this.state = {
      selectedCategory:[],
      selectProcess:[]
      }
    }
    componentWillMount(){
      const{selectedprocessName} = this.props;      
      this.setState({selectProcess:selectedprocessName})
      if(!_.isEmpty(selectedprocessName)){
      _.map(selectedprocessName, (obj, i) =>{
        let index = _.findIndex(this.props.process, {'inventoryProcessId':obj.inventoryProcessId})
        let process = _.find(this.props.process, {'inventoryProcessId':obj.inventoryProcessId})
        if(!_.isEmpty(process)){
          if(_.has(obj, 'inventoryCategoryId')){
            this.setState({['selectedCategory'+index]:{'id':obj.inventoryCategoryId, 'label':obj.inventoryCategoryName}})
          }
        }
       this.setState({checkSelected:index})

      })
     }
    }
    handleSelectCategory = (i, e) =>{
      const{selectProcess} = this.state;
      const{process} = this.props;
      this.setState({['selectedCategory'+i]:e})
      let a  = _.isEqual(selectProcess.inventoryProcessId, process[i].inventoryProcessId)
      if(a === true){
        selectProcess['inventoryCategoryId'] = e.id        
        selectProcess['inventoryCategoryName'] = e.label 
        this.setState({selectProcess})     
      }      

    }
    handleSelected = () =>{
      let x = _.cloneDeep(this.state.selectProcess)
      this.props.callBack(x)
      this.props.handleClose()
    }
    handleSelectedProcess = (i, e) =>{
      const{process} = this.props
     // const {selectProcess} = this.state;
      this.setState({checkSelected:i, selectProcess:process[i]})
      if(!_.isEqual(this.state.checkSelected, i)){
        this.setState({['selectedCategory'+this.state.checkSelected]:[]})
      }
      //this.setState({['selectedCategory'+i]:[]})
      // } else {    
      //   _.pullAllBy(selectProcess, [process[i]], 'inventoryProcessId')  
      //   
      // }
     // this.setState({selectProcess})
    }
    
    render(){
      return(
      <Modal 
      show={true}
      onHide={this.props.handleClose}
      dialogClassName="modal-120w"
      size='md'
      aria-labelledby="contained-modal-title-vcenter"
      centered>  
      <Modal.Header closeButton>
        <Modal.Title>Select Process & Agent Categories</Modal.Title></Modal.Header>   
      <Modal.Body>
        <Table responsive>
          <thead><th></th><th>Process</th><th>Agent Categories</th></thead>
          <tbody>
             {_.map(this.props.process, (obj, i) =>{
               return(
                 <tr>
                   <td><input type="radio" checked={this.state['checkSelected'] === i } onClick={(e)=>this.handleSelectedProcess(i, e)} /></td>
                   <td>{obj.inventoryProcessName}</td>
                   <td><Picky keepOpen={false}
                      value={this.state['selectedCategory'+i] ? this.state['selectedCategory'+i] : []}
                      options={this.props.categories}
                      onChange={(e)=>this.handleSelectCategory(i, e)}
                      open={false}
                      valueKey="label"
                      labelKey="label"
                      multiple={false}
                      includeSelectAll={true}
                      includeFilter={false}
                      placeholder='Select Category'
                      dropdownHeight={600}
                    /></td>
                 </tr>
               )
             })

             }
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
      <Button onClick={this.handleSelected}> OK </Button> &nbsp;
      <Button onClick={this.props.handleClose}> Cancel </Button>
      </Modal.Footer>
      </Modal>
      )
    }
    
 
}

  